import MNPG_001 from "./components/MNPG_001";
import MNPG_002 from "./components/MNPG_002";
import MNPG_003 from "./components/MNPG_003";
import MNPG_004 from "./components/MNPG_004";
import MNPG_005 from "./components/MNPG_005";
import MNPG_006 from "./components/MNPG_006";
import MNPG_007 from "./components/MNPG_007";
import MNPG_008 from "./components/MNPG_008";
import MNPG_009 from "./components/MNPG_009";
import MNPG_010 from "./components/MNPG_010";
import MNPG_020 from "./components/MNPG_020";
import MNPG_021 from "./components/MNPG_021";
import MNPG_022 from "./components/MNPG_022";
import MNPG_023 from "./components/MNPG_023";
import MNPG_024 from "./components/MNPG_024";
import MNPG_048 from "./components/MNPG_048";
import MNPG_049 from "./components/MNPG_049";


const MainPageLayouts:any = {
    
    MNPG_001,
    MNPG_002,
    MNPG_003,
    MNPG_004,
    MNPG_005,
    MNPG_006,
    MNPG_007,
    MNPG_008,
    MNPG_009,
    MNPG_010,
    MNPG_020,
    MNPG_021,
    MNPG_022,
    MNPG_023,
    MNPG_024,
    MNPG_048,
    MNPG_049

}

export type TMainPageLayouts = 'MNPG_001'|'MNPG_002'|'MNPG_003'|'MNPG_004'|'MNPG_005'|'MNPG_006'|'MNPG_007'|'MNPG_008'|'MNPG_009'|'MNPG_010'|'MNPG_011'|'MNPG_012'|'MNPG_013'|'MNPG_014'|'MNPG_015'|'MNPG_016'|'MNPG_017'|'MNPG_018'|'MNPG_019'|'MNPG_020'|'MNPG_021'|'MNPG_022'|'MNPG_023'|'MNPG_024'|'MNPG_025'|'MNPG_026'|'MNPG_027'|'MNPG_028'|'MNPG_029'|'MNPG_030'|'MNPG_031'|'MNPG_032'|'MNPG_033'|'MNPG_034'|'MNPG_035'|'MNPG_036'|'MNPG_037'|'MNPG_038'|'MNPG_039'|'MNPG_040'|'MNPG_041'|'MNPG_042'|'MNPG_043'|'MNPG_044'|'MNPG_045'|'MNPG_046'|'MNPG_047'|'MNPG_048'|'MNPG_049'|'MNPG_050'|'MNPG_051'|'MNPG_052'|'MNPG_053'|'MNPG_054'|'MNPG_055'|'MNPG_056'|'MNPG_057'|'MNPG_058'|'MNPG_059';

export default MainPageLayouts;
